
import Product from 'layouts/product/Product.js';
import ProtectedRoute from "routes/protectedRoutes.js";
import Manage from 'layouts/product/ManageProducts';

const ProductRoutes = [

  {
    route: "products/edit/:productId",
    key: "EditProduct",
    component: <ProtectedRoute check="logout"><Product /></ProtectedRoute>
  },
  {
    route: "/products/manage/:pageNo",
    key: "manage-products",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }
  ];

export default ProductRoutes;
 
